import { TzDatabase } from 'timezonecomplete';
import tzdata from 'tzdata';

TzDatabase.init([tzdata]);

export default TzDatabase;
